import Controller from '@ember/controller';
import updateAndSaveTask from 'garaje/utils/decorators/update-and-save-task';

@updateAndSaveTask
class LocationOverviewSignInFlowsShowVisitorPhotosController extends Controller {}

export default LocationOverviewSignInFlowsShowVisitorPhotosController;
